import { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import ClientOnly from "./ClientOnly";

// These components use browser APIs (localStorage, window, tRPC hooks)
// and must only render on the client side
import MobileCTA from "./MobileCTA";
import BackToTop from "./BackToTop";
import AnnouncementBanner from "./AnnouncementBanner";

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Skip navigation for accessibility (WCAG 2.1) */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-6 focus:py-3 focus:bg-[#2563EB] focus:text-white focus:font-semibold focus:rounded-md focus:shadow-lg focus:outline-none"
      >
        Hoppa till huvudinnehåll
      </a>
      <ClientOnly>
        <AnnouncementBanner />
      </ClientOnly>
      <Header />
      <main id="main-content" className="flex-1">{children}</main>
      <Footer />
      <ClientOnly>
        <MobileCTA />
        <BackToTop />
      </ClientOnly>
    </div>
  );
}
